<template>
<ul class="list_movie" v-if="selectedCameraInfo !== null && historyList.length && isActiveListMovie === true">
    <li class="clearfix">

        <!-- 実行確認用のモーダル -->
        <Confirm
            ref="confirm"
            @cancel="modifyStatusDelte"
            @execution="modifyStatusChange"
            :message="confirmMessage"
            :subMessage="confirmSubMessage"
            :canselButtonName="confirmCancelMessage"
            :executionButtonName="confirmExecMessage"
        />

        <!-- 履歴の動画一覧に対して操作を行う各種ボタン -->
        <div v-if="is_thumbnailHourCount > 0" class="list_header clearfix">
            <h3 class="term-name"><span class="rec">●<span>動画</span></span>{{selectedCameraInfo[1]}}</h3>
            <div class="archive-btn">
                <div>
                    <button v-if="is_multiSelect===false" class="-select" @click="multiSelect()">選択</button>
                    <button v-else class="-select -cancel" @click="multiSelect()">キャンセル</button>
                    <button v-if="is_multiSelect===true" class="-select -allSelect" @click="allCheck()">全選択</button>
                    <button v-if="is_multiSelect===true" class="-play" @click="selectContinuousReproduction()" disabled="">連続再生</button>
                    <button v-if="historyDataDelete && is_multiSelect===true" class="-delete" @click="selectDelete()" disabled>削除</button>
                </div>
                <div>
                    <button v-if="is_onedayDownloadButton" class="-oneday-download" @click="judgeOnedayDownloadMovie()">一括ダウンロード</button>
                    <button v-else class="-oneday-download" disabled>一括ダウンロード</button>
                    <div class="question-icon" @touchstart="showBallon()"></div>
                    <div class="noticeMessage">
                        <p>1日分の動画ファイルは撮影日の翌日朝からダウンロード可能です</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 履歴の動画一覧 -->
        <div class="history_list" v-for="(historylist, historylist_key) in historyList" :key="historylist_key">
            <h4 v-if="historylist.sequence !== 0">{{historylist.hour}}:00</h4>
            <ul v-if="historylist.sequence !== 0" class="clearfix_pc">
                <li v-for="n of historylist.sequence" :key="n" :id="'thumbnail_' + historylist[n].datetime" class="thumbnail">
                    <span class="img_for_modal" @click="clickMove(historylist_key, n, selectedCameraInfo[0], historylist[n].datetime, 600); checkThumbnail(historylist[n].datetime)">

                        <span class="thumbnail-label">{{ historylist[n].datetime | datetimeFormat }}</span>

                        <!-- サムネイル画像がS3に存在するか確認し、画像読み込み処理実行 && 画像読み込み回数を監視して、ローディングアイコンを非表示にする処理-->
                        <img v-if='historylist[n].image_url_thumbnail !== ""' :src="historylist[n].image_url_thumbnail" @load="loaded" />
                        <img v-else-if='historylist[n].image_url_thumbnail === ""' :src="historylist[n].image_url_static" @load="loaded" />
                        <img v-else :src="noImageUrl" @load="loaded" />


                        <input
                            @click="checkThumbnail(historylist[n].datetime)"
                            type="checkbox"
                            v-if="is_multiSelect === true"
                            class="multiSelectCheckBox selectedThumbnail"
                            :id="'checkThumbnail_' + historylist[n].datetime"
                            :name="historylist_key + '_' + n + '_' + selectedCameraInfo[0]"
                        />
                        <label :for="historylist_key + '_' + n + '_' + selectedCameraInfo[0]"></label>

                        <!-- 選択ボタンを押下判定に応じて再生アイコンを表示または非表示にする処理 -->
                        <div v-if="is_multiSelect===true" style="background-image: inherit;" class="play"></div>
                        <div v-else class="play"></div>

                    </span>
                    <span class="movie-download-button" @click="judgeSelectedDownloadMovie(historylist[n].datetime)">
                        <span class="download-icon"></span>
                    </span>
                </li>
            </ul>
        </div>

    </li>
</ul>
</template>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;

import Confirm from '../modal/Confirm'
import $ from 'jquery'// eslint-disable-line

export default {
    name: 'HistoryMovieLists',
    data() {
        return {
            // サムネイル一覧情報の配列
            formatHistoryList: {},

            // ローディング済みのサムネイルをカウントして格納
            loadedCount: 0,

            // 複数選択が有効か判定
            is_multiSelect: false,

            // 画像がない場合にNoImageを読み込む
            noImageUrl: require("../../assets/images/no_image.png"),

            // 連続再生用の動画情報一覧
            continuousReproductionList: {},

            // 連続再生の動画を進める値
            nextMovieNo: 0,

            // 実行確認モーダル用のパーツ
            confirmMessage: '',
            confirmSubMessage: '',
            confirmCancelMessage: '',
            confirmExecMessage: '',
            deleteFlg: false,

            // サムネイル毎のダウンロードするか判断する値
            downloadFlg: false,

            // 1日ダウンロードするか判断する値
            onedayDownloadFlg: false,

            // ダウンロード対象の動画の日付を格納
            downloadMovieForUnixtime: '',
        }
    },
    props:{
        // 履歴データを格納
        historyList:{
            type: Array
        },

        // 選択したカメラ情報を格納
        selectedCameraInfo:{
            type: Array
        },

        // 選択中の動画の情報を格納
        isActiveListMovie:{
            type: Boolean
        },

        // 端末グループ情報を格納
        siteInfo: {
            type: Array
        },

        // サムネイルの合計した数値を格納
        is_thumbnailHourCount: {
            type: Number
        },

        // 選択した日付をunixtimeで格納(一括ダウンロードの際に渡すための日付)
        timeStartUnixtime: {
            type: Number
        },

        // 一括ダウンロードボタンが活性/非活性か格納
        is_onedayDownloadButton: {
            type: Boolean
        },

        // 一括ダウンロードする際のファイルの合計サイズを格納(GB)
        mediaFilesize: {
            type: String
        }
    },
    methods: {
        /**********************************************************/
        // 画面タップ時に吹き出しを表示
        /**********************************************************/
        showBallon() {
            var target = document.getElementsByClassName("noticeMessage");
            target[0].style.display = "block";
        },

        /**********************************************************/
        // 動画選択時にサムネイルにチェックを可能にする処理
        /**********************************************************/
        checkThumbnail(thumbnailUnixtie) {
            if (this.is_multiSelect === true) {
                var target = document.getElementById("checkThumbnail_" + thumbnailUnixtie);
                if (target !== null) {
                    if(target.checked) {
                        target.checked = false;
                    } else {
                        target.checked = true;
                    }
                }
                var checkThumbnailCount = 0;
                var selectedThumbnail = document.getElementsByClassName('selectedThumbnail');
                for (var i = 0; i < selectedThumbnail.length; i++) {
                    if (selectedThumbnail[i].checked === true) {
                        checkThumbnailCount++;
                    }
                }
                if (checkThumbnailCount !== 0) {
                    if (this.$userRoleAuthorization('history', 'historyDataDelete')) {
                        document.getElementsByClassName('-delete')[0].removeAttribute("disabled");
                    }
                    document.getElementsByClassName('-play')[0].removeAttribute("disabled");
                } else {
                    if (this.$userRoleAuthorization('history', 'historyDataDelete')) {
                        document.getElementsByClassName('-delete')[0].setAttribute("disabled", true);
                    }
                    document.getElementsByClassName('-play')[0].setAttribute("disabled", true);
                }
            }
        },

        /**********************************************************/
        // サムネイルを全て読み込み完了で実行
        /**********************************************************/
        loaded() {
            this.loadedCount++
            if(this.loadedCount === Object.keys(this.formatHistoryList).length) {
                this.loadedCount = 0;
                this.$emit('finished');
            }
        },

        /**********************************************************/
        // サムネイルをクリックした時の処理
        // 親コンポーネントに、各引数と必要な情報を送る
        /**********************************************************/
        // 引数
        // thumnail_hour      : クリックしたサムネイルの時間
        // thumnail_num_hour  : クリックしたサムネイルの1時間内の何番目
        // termId             : クリックした端末ID
        // dateTime           : クリックしたサムネイルの時間
        // endingTime         : クリックした端末のサムネイル再生終了時間
        /**********************************************************/
        clickMove(thumnail_hour, thumnail_num_hour, termId, dateTime, endingTime) {
            var count = 0;
            for (let step = 0; step < thumnail_hour; step++) {
                var list = this.historyList[step];
                count = count + list.sequence;
            }
            count = count + thumnail_num_hour -1;
            this.$emit('modalOpen', {key:count, term_id:termId, datetime:dateTime, endingTime: endingTime});
        },

        /**********************************************************/
        // 複数選択をクリックした時の処理
        /**********************************************************/
        multiSelect() {
            this.is_multiSelect = !this.is_multiSelect;
            this.$emit('isActiveMultiSelect', this.is_multiSelect);
            if (this.is_multiSelect === false) {
                if (this.$userRoleAuthorization('history', 'historyDataDelete')) {
                    document.getElementsByClassName('-delete')[0].setAttribute("disabled", true);
                }
                document.getElementsByClassName('-play')[0].setAttribute("disabled", true);
            }
        },

        /**********************************************************/
        // 全選択をクリックした時の処理
        /**********************************************************/
        allCheck() {
            if (this.is_multiSelect === true) {
                var selectedThumbnail = document.getElementsByClassName('selectedThumbnail');
                for (var i = 0; i < selectedThumbnail.length; i++) {
                    selectedThumbnail[i].checked = true;
                }
                if (this.$userRoleAuthorization('history', 'historyDataDelete')) {
                    document.getElementsByClassName('-delete')[0].removeAttribute("disabled");
                }
                document.getElementsByClassName('-play')[0].removeAttribute("disabled");
            }
        },

        /**********************************************************/
        // 動画の削除確認モーダルを表示
        /**********************************************************/
        selectDelete() {
            var selectedThumbnail = document.getElementsByClassName('selectedThumbnail');
            for (var i = 0; i < selectedThumbnail.length; i++) {
                if (selectedThumbnail[i].checked === true) {
                    this.deleteFlg = true;
                    this.confirmMessage = "動画削除";
                    this.confirmSubMessage = "選択した動画を削除します。よろしいですか？";
                    this.confirmCancelMessage = "キャンセル";
                    this.confirmExecMessage = "削除する";
                    this.$refs.confirm.showConfirm();
                    break;
                }
            }
            var deleteBtnChange = document.getElementsByClassName('confirmDeleteBtn')[0];
            deleteBtnChange.style.background = "linear-gradient(135deg,  #aa0000 0%,#ff0000 100%)";
        },

        /**********************************************************/
        // 動画の削除処理を実行
        /**********************************************************/
        deleteThumbnail() {
            scrollTo(0, 0);
            this.$emit('loadStart');
            var deleteThumbnailUnixtime = '';
            var selectedThumbnail = document.getElementsByClassName('selectedThumbnail');
            for (var i = 0; i < selectedThumbnail.length; i++) {
                if (selectedThumbnail[i].checked === true) {
                    var thumbnailUnixtime = selectedThumbnail[i].id.substr(15);
                    deleteThumbnailUnixtime += thumbnailUnixtime + ',';
                }
            }
            deleteThumbnailUnixtime = deleteThumbnailUnixtime.slice(0, -1);
            if (deleteThumbnailUnixtime !== '') {
                var siteNo = this.siteInfo[0].site_no;
                var termId = this.selectedCameraInfo[0];
                var queriesArchive = { times_delete: deleteThumbnailUnixtime};
                var liveAccessToken = this.$store.getters['auth/getLiveAccessToken'];
                this.$store.dispatch('requestApi/deleteApiInfoAction', {
                    url: apiUrl + 'streams/archive/' + siteNo + '/' + termId + '?live_access_token=' + liveAccessToken,
                    params: queriesArchive
                }).then(response => {//eslint-disable-line
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: true,
                        message:"動画削除成功",
                        sub_message:"動画の削除が完了しました。",
                        errorFlag: false
                    });
                    document.getElementsByClassName('-delete')[0].setAttribute("disabled", true);
                    document.getElementsByClassName('-play')[0].setAttribute("disabled", true);
                    this.$emit('finished');
                }, error => {//eslint-disable-line
                    if (error == "Error: Request failed with status code 401") {
                        sessionStorage.clear();
                        window.localStorage.removeItem('TodoApp');
                        this.$emit('showResultMessage', {
                            transitionLogoutPageFlg: true,
                            transitionTopPageFlg: false,
                            execFlg: false,
                            message:"エラー",
                            sub_message:"ログインし直してください。",
                            errorFlag: true
                        });
                    } else if (error == "Error: Request failed with status code 403") {
                        this.$emit('showResultMessage', {
                            transitionLogoutPageFlg: false,
                            transitionTopPageFlg: true,
                            execFlg: false,
                            message:"権限エラー",
                            sub_message:"アクセス権がありません。",
                            errorFlag: true
                        });
                    } else {
                        this.$emit('showResultMessage', {
                            transitionLogoutPageFlg: false,
                            transitionTopPageFlg: false,
                            execFlg: false,
                            message:"動画削除失敗",
                            sub_message:"動画の削除が失敗しました。",
                            errorFlag: true
                        });
                    }
                    this.$emit('finished');
                })
            }
        },
        deleteMovieStatusChange() {
            this.deleteThumbnail();
            this.$refs.confirm.hiddenConfirm();
        },

        /**********************************************************/
        // 連続再生を関する処理
        /**********************************************************/
        selectContinuousReproduction() {
            var selectedThumbnail = document.getElementsByClassName('selectedThumbnail');
            var thumbnailUnixtimeList = [];
            for (var i = 0; i < selectedThumbnail.length; i++) {
                if (selectedThumbnail[i].checked === true) {
                    var thumbnailUnixtime = Number(selectedThumbnail[i].id.substr(15));
                    thumbnailUnixtimeList.push(thumbnailUnixtime);
                }
            }
            this.continuousReproductionList = {};
            var ascThumbnailUnixtimeList = thumbnailUnixtimeList.sort();
            for (var j = 0; j < ascThumbnailUnixtimeList.length; j++) {
                var target = document.getElementById("checkThumbnail_" + ascThumbnailUnixtimeList[j]);
                var ascThumbnailUnixtime = ascThumbnailUnixtimeList[j];
                var thumbnailKeyInfo = target.name.split('_');
                var thumnail_hour = Number(thumbnailKeyInfo[0]);
                var thumnail_num_hour = Number(thumbnailKeyInfo[1]);
                var termId = thumbnailKeyInfo[2]
                this.$set(this.continuousReproductionList, j, {"term_id":termId, "thumbnailUnixtime":ascThumbnailUnixtime, "thumnail_hour":thumnail_hour, "thumnail_num_hour":thumnail_num_hour});
            }
            this.nextMovieNo = 0;
            this.$emit('changeContinuousReproductionOption', true);
            this.clickMove(this.continuousReproductionList[this.nextMovieNo].thumnail_hour, this.continuousReproductionList[this.nextMovieNo].thumnail_num_hour, this.continuousReproductionList[this.nextMovieNo].term_id, this.continuousReproductionList[this.nextMovieNo].thumbnailUnixtime, 600)

            this.$nextTick(function () {
                if (Object.keys(this.continuousReproductionList).length > 1) {
                    document.getElementsByClassName('next-button')[0].style.display = "";
                }
            })
        },

        /**********************************************************/
        // 連続再生時に次の動画に移動する処理
        /**********************************************************/
        chageNextMovie() {
            this.nextMovieNo++;
            if (this.continuousReproductionList[this.nextMovieNo] !== undefined) {
                this.clickMove(this.continuousReproductionList[this.nextMovieNo].thumnail_hour, this.continuousReproductionList[this.nextMovieNo].thumnail_num_hour, this.continuousReproductionList[this.nextMovieNo].term_id, this.continuousReproductionList[this.nextMovieNo].thumbnailUnixtime, 600)
                document.getElementsByClassName('back-button')[0].style.display = "";
                var checkNextMovieNo = this.nextMovieNo + 1;
                if (this.continuousReproductionList[checkNextMovieNo] === undefined) {
                    document.getElementsByClassName('next-button')[0].style.display = "none"
                }
            } else {
                this.nextMovieNo--;
            }
        },

        /**********************************************************/
        // 連続再生時に前の動画に移動する処理
        /**********************************************************/
        chageBackMovie() {
            this.nextMovieNo--;
            if (this.continuousReproductionList[this.nextMovieNo] !== undefined) {
                this.clickMove(this.continuousReproductionList[this.nextMovieNo].thumnail_hour, this.continuousReproductionList[this.nextMovieNo].thumnail_num_hour, this.continuousReproductionList[this.nextMovieNo].term_id, this.continuousReproductionList[this.nextMovieNo].thumbnailUnixtime, 600)
                document.getElementsByClassName('next-button')[0].style.display = ""
                var checkBackMovieNo = this.nextMovieNo - 1;
                if (this.continuousReproductionList[checkBackMovieNo] === undefined) {
                    document.getElementsByClassName('back-button')[0].style.display = "none"
                }
            } else {
                this.nextMovieNo++;
            }
        },

        /**********************************************************/
        // 動画の単体ダウンロードする処理
        /**********************************************************/
        downloadMovie(unixtime) {
            this.$refs.confirm.hiddenConfirm();
            this.$emit('loadStart');
            var siteNo = this.siteInfo[0].site_no;
            var termId = this.selectedCameraInfo[0];
            var endTime = unixtime + 600;
            var queriesArchive = {
                live_access_token: this.$store.getters['auth/getLiveAccessToken'],
                time_play_start: unixtime,
                time_play_end: endTime
            };
            this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + 'streams/mediaclip/' + siteNo + '/' + termId + '/endpoint',
                params: queriesArchive
            }).then(response => {//eslint-disable-line
                this.$emit('finished');
                this.$emit('showResultMessage', {
                    transitionLogoutPageFlg: false,
                    transitionTopPageFlg: false,
                    execFlg: false,
                    message:"動画ダウンロード準備完了",
                    sub_message:"動画のダウンロード準備が完了しました。",
                    errorFlag: false
                });
                document.location.href = this.$store.getters["requestApi/getApiInfo"][0].media_clip_url;
            }, error => {//eslint-disable-line
                this.$emit('finished');
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"動画ダウンロード準備失敗",
                        sub_message:"動画のダウンロード準備が失敗しました。",
                        errorFlag: true
                    });
                }
            })
        },

        /**********************************************************/
        // 動画の一括ダウンロードをする処理
        /**********************************************************/
        onedayDownloadMovie() {
            this.$refs.confirm.hiddenConfirm();
            this.$emit('loadStart');
            var siteNo = this.siteInfo[0].site_no;
            var termId = this.selectedCameraInfo[0];
            var queriesArchive = {
                live_access_token: this.$store.getters['auth/getLiveAccessToken'],
                time_play_start: this.timeStartUnixtime
            };
            this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + 'streams/download/' + siteNo + '/' + termId + '/endpoint',
                params: queriesArchive
            }).then(response => {//eslint-disable-line
                this.$emit('finished');
                this.$emit('showResultMessage', {
                    transitionLogoutPageFlg: false,
                    transitionTopPageFlg: false,
                    execFlg: false,
                    message:"動画ダウンロード準備完了",
                    sub_message:"動画のダウンロード準備が完了しました。",
                    errorFlag: false
                });
                document.location.href = this.$store.getters["requestApi/getApiInfo"].media_clip_url;
            }, error => {//eslint-disable-line
                this.$emit('finished');
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"動画ダウンロード準備失敗",
                        sub_message:"動画のダウンロード準備が失敗しました。",
                        errorFlag: true
                    });
                }
            })
        },

        //**********************************************************/
        // 選択した動画をダウンロードするかどうか確認
        /**********************************************************/
        judgeSelectedDownloadMovie(unixtime) {
            this.downloadMovieForUnixtime = unixtime;
            this.downloadFlg = true;
            this.confirmMessage = "動画ダウンロード";
            this.confirmSubMessage = "選択した動画をダウンロードします(約19MB)。よろしいですか？";
            this.confirmCancelMessage = "キャンセル";
            this.confirmExecMessage = "ダウンロード";
            this.$refs.confirm.showConfirm();
        },

        //**********************************************************/
        // 選択した動画をダウンロードするかどうか確認
        /**********************************************************/
        judgeOnedayDownloadMovie() {
            this.onedayDownloadFlg = true;
            this.confirmMessage = "動画一括ダウンロード";
            this.confirmSubMessage = "1日分の動画をダウンロードします(" + this.mediaFilesize + ")。よろしいですか？";
            this.confirmCancelMessage = "キャンセル";
            this.confirmExecMessage = "ダウンロード";
            this.$refs.confirm.showConfirm();
        },

        //**********************************************************/
        // 変更確認ポップアップの表示後、キャンセルを押した場合の処理
        /**********************************************************/
        modifyStatusDelte() {
            // 以下、動画削除および動画ダウンロードの有無状態を管理しているフラグを初期化する処理
            this.deleteFlg = false;
            this.downloadFlg = false;
            this.onedayDownloadFlg = false;
            this.downloadMovieForUnixtime = "";
            var deleteBtnChange = document.getElementsByClassName('confirmDeleteBtn')[0];
            deleteBtnChange.style.background = "";
        },

        /**********************************************************/
        // 各変更確認ポップアップの判定をする処理
        /**********************************************************/
        modifyStatusChange() {
            if (this.deleteFlg === true) {
                this.deleteMovieStatusChange();
            }
            if (this.downloadFlg === true) {
                this.downloadMovie(this.downloadMovieForUnixtime);
            }
            if (this.onedayDownloadFlg === true) {
                this.onedayDownloadMovie();
            }
            this.deleteFlg = false;
            this.downloadFlg = false;
            this.onedayDownloadFlg = false;
            this.downloadMovieForUnixtime = "";
        },
    },
    computed: {
        /**********************************************************/
        // データ削除の表示非表示
        /**********************************************************/
        historyDataDelete() {
            return this.$userRoleAuthorization('history', 'historyDataDelete');
        },
    },
    watch: {
        historyList: {
            handler(){
                /**********************************************************/
                // 適用ボタンを押した時に複数選択のチェックを全て外す
                /**********************************************************/
                var selectedThumbnail = document.getElementsByClassName('selectedThumbnail');
                for (var j = 0; j < selectedThumbnail.length; j++) {
                    if (selectedThumbnail[j].checked === true) {
                        selectedThumbnail[j].checked = false;
                    }
                }

                /**********************************************************/
                // historyListの配列を整形
                /**********************************************************/
                this.formatHistoryList = {};
                for (var hour = 0; hour <= this.historyList.length - 1; hour++) {
                    if (this.historyList[hour].sequence != 0) {
                        for (var i = 1; i <= this.historyList[hour].sequence; i++) {
                            this.$set(this.formatHistoryList, hour + '_' + i, this.historyList[hour][i]);
                        }
                    }
                }
                /**********************************************************/
                // サムネイル画像が1枚も存在しない場合にロードを終了させる
                /**********************************************************/
                if(this.is_thumbnailHourCount === 0) {
                    this.$emit('finished');
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"該当データなし",
                        sub_message:"保存されているデータがありません。",
                        errorFlag: true
                    });
                }
            },
            deep: true
        },
    },
    /**********************************************************/
    // 画像上の時刻表示用に日時をフォーマット
    /**********************************************************/
    filters: {
        datetimeFormat(unixtime){
            var dateTime = new Date(unixtime * 1000);
            var year = dateTime.getFullYear();
            var mon = ( dateTime.getMonth() + 1 < 10 ) ? ( '0' + ( dateTime.getMonth() + 1 ) ) : dateTime.getMonth() + 1;
            var day = ( dateTime.getDate() < 10 ) ? '0' + dateTime.getDate() : dateTime.getDate();
            var hour = ( dateTime.getHours()   < 10 ) ? '0' + dateTime.getHours()   : dateTime.getHours();
            var min  = ( dateTime.getMinutes() < 10 ) ? '0' + dateTime.getMinutes() : dateTime.getMinutes();
            return year + '/' + mon + '/' + day + ' ' + hour + ':' + min;
        }
    },
    async mounted() {
        //**********************************************************/
        // ？アイコン以外をタップした場合に吹き出しを非表示にする
        /**********************************************************/
        document.addEventListener('touchstart', (e) => {
            if(!e.target.closest('.question-icon')) {
                var target = document.getElementsByClassName("noticeMessage");
                if (target.length > 0) {
                    target[0].style.display = "";
                }
            }
        })
    },
    components: {
        Confirm,
    },
}
</script>

<style lang="scss" scoped>
@import url(../../assets/css/main/HistoryMovieLists.css);
</style>